// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-70bd01fe] .el-input__inner{border:0;margin:0;padding:0 15px;background-color:transparent}.input-number-range[data-v-70bd01fe]{background-color:#fff;border:1px solid #dcdfe6;border-radius:4px}.flex[data-v-70bd01fe]{display:flex;flex-direction:row;width:100%;height:auto;justify-content:center;align-items:center}.flex .center[data-v-70bd01fe]{margin-top:1px}.is-disabled[data-v-70bd01fe]{background-color:#f5f7fa;border-color:#e4e7ed;color:#c0c4cc;cursor:not-allowed}", ""]);
// Exports
module.exports = exports;
